var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckmarkWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon /\xA0green_checkmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HSP-view",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HSP-v2---live-cards-Copy",
    transform: "translate(-187.000000, -464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(84.000000, 178.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card1",
    transform: "translate(23.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(-3.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-green_checkmark",
    transform: "translate(83.750000, 99.571429)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 9.375,
    cy: 9.52380952,
    rx: 9.375,
    ry: 9.52380952
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48197115,14.3086081 L15.9329928,5.72344322 L14.6033654,4.32692308 L7.48197115,11.5842491 L4.14663462,8.17307692 L2.81700721,9.52380952 L7.48197115,14.3086081 Z M9.375,0 C11.0877489,0 12.6727692,0.434977335 14.1301082,1.30494505 C15.5423748,2.129125 16.6541426,3.25853984 17.4654447,4.69322344 C18.3218192,6.17369483 18.75,7.78387408 18.75,9.52380952 C18.75,11.263745 18.3218192,12.8739242 17.4654447,14.3543956 C16.6541426,15.7890792 15.5423748,16.918494 14.1301082,17.742674 C12.6727692,18.6126417 11.0877489,19.047619 9.375,19.047619 C7.66225105,19.047619 6.07723084,18.6126417 4.61989183,17.742674 C3.20762515,16.9032315 2.09585742,15.7661854 1.28455529,14.3315018 C0.428180814,12.8510304 0,11.2484824 0,9.52380952 C0,7.79913668 0.428180814,6.1965886 1.28455529,4.71611722 C2.11088154,3.28143361 3.23016121,2.14438759 4.64242788,1.30494505 C6.0997669,0.434977335 7.67727517,0 9.375,0 Z",
    id: "Success-icon",
    fill: "#68AC58",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckmarkWhite);
export default __webpack_public_path__ + "static/media/green_checkmark_white.12ea6a146fee69fda2b2f4370e68e99e.svg";
export { ForwardRef as ReactComponent };